import React from "react";
import {
  VideoCommerceContainerStyled,
  ListControlsContainerStyled,
  BackIconWrapper,
  BackIconStyled,
  CloseIconTextStyled
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { trackEvent } from "../../services/analyticsService";
import { Heading, Icon, withFocusable, TypedCarousel } from "../../services/visualLibraryService";
import { withAppState } from "../../state";

export const defaultFocusPath = "videoCommerceCard";
const TypedCarouselFocus = withFocusable(TypedCarousel);
const CAROUSEL_TYPE = "videoCommerceList";
const VC = "VIDEO_COMMERCE";
let visitedCardsIndex = [];
class VideoCommerceList extends React.Component {
  constructor(props) {
    super(props);
    this.cards = {};
    this.onChangeItem = this.onChangeItem.bind(this);
    this.onLeft = this.onLeft.bind(this);
    this.onRight = this.onRight.bind(this);
    this.sendTrackData = this.sendTrackData.bind(this);
    this.onClickPoster = this.onClickPoster.bind(this);
  }

  componentDidMount() {
    // set Initial focus of first item
    this.props.stateActions.setCarouselItemFocus(0);
    this.sendTrackData(0);
  }

  componentWillUnmount() {
    visitedCardsIndex = [];
  }
  onChangeItem(index) {
    this.props.stateActions.setCarouselItemFocus(index);
  }
  sendTrackData(index) {
    if (visitedCardsIndex.includes(index)) return;
    visitedCardsIndex.push(index);
    const item = this.props.list[index];
    trackEvent("adtech_vc_impression", null, VC, item);
  }

  onLeft(type) {
    if (this.props.showQRCodeModal) return;
    const { focusedCarouselItemIndex: index } = this.props.applicationState;
    if (this.props.list.length > visitedCardsIndex.length) {
      if (!index) {
        this.sendTrackData(this.props.list.length - 1);
      } else {
        this.sendTrackData(index - 1);
      }
    }
    this.cards[type].left();
  }

  onRight(type) {
    if (this.props.showQRCodeModal) return;
    const { focusedCarouselItemIndex: index } = this.props.applicationState;
    if (this.props.list.length > visitedCardsIndex.length) {
      this.sendTrackData(index + 1);
    }
    this.cards[type].right();
  }

  onClickPoster(itemIndex) {
    this.cards[CAROUSEL_TYPE].goTo(itemIndex);
    this.props.vcHandler(itemIndex);
  }

  render() {
    const { list, wheelState, vcHandler, vcBackHandler } = this.props;
    const { focusedCarouselItemIndex } = this.props.applicationState;

    return (
      <>
        <VideoCommerceContainerStyled>
          <ListControlsContainerStyled>
            <Heading text={i18n.get("pages.player.videoCommerce.heading")} type="white" rank={5} size="xmedium" />
            <BackIconWrapper>
              <CloseIconTextStyled direction={i18n.getDirection()}>
                {i18n.get("pages.player.videoCommerce.closeIconTextPress")}
              </CloseIconTextStyled>
              <BackIconStyled onClick={vcBackHandler}>
                <Icon name={"popup_back"} viewBoxValue="0 0 40 40" height="2.5rem" fill="#000000" />
              </BackIconStyled>
              <CloseIconTextStyled direction={i18n.getDirection()}>
                {i18n.get("pages.player.videoCommerce.closeIconTextToClose")}
              </CloseIconTextStyled>
            </BackIconWrapper>
          </ListControlsContainerStyled>
          <TypedCarouselFocus
            type={CAROUSEL_TYPE}
            items={list}
            focusPath={defaultFocusPath}
            initialSlide={0}
            slideMargin={"0.4rem"}
            onRef={ref => (this.cards[CAROUSEL_TYPE] = ref)}
            onChangeItem={this.onChangeItem}
            onClickPoster={i => this.onClickPoster(i)}
            onEnterPress={() => vcHandler(focusedCarouselItemIndex)}
            onLeft={this.onLeft.bind(this, CAROUSEL_TYPE)}
            onRight={this.onRight.bind(this, CAROUSEL_TYPE)}
            direction={i18n.getDirection()}
            marginBottom={props => props.theme.spacing.xxsmall}
            MagicRemoteStatus={wheelState === "active" ? true : false}
            showArrows={wheelState === "active" ? true : false}
          />
        </VideoCommerceContainerStyled>
      </>
    );
  }
}

VideoCommerceList.defaultFocusPath = defaultFocusPath;

export default withAppState(VideoCommerceList);
